import React from 'react';
import Transactions from '.';

const DepositTransactions = () => (
  <>
    <Transactions
      title="Settlement Transactions"
      transactionType="DEPOSIT"
    />
  </>
);

export default DepositTransactions;
